/** Who may act on a compliance row, and which rows are still open. */
import { ComplianceFlagBoardRow, FlagStatus, JobSecurityRight } from '@jms/model';
import { RightsService } from '@jms/utils/util.permissions';

/** Book now and Close both need Manage Jobs; the API enforces the same right on both. */
export function canActOnCompliance(rights: RightsService): boolean {

  return rights.hasRights(JobSecurityRight.Manage);
}

export function isOpenCompliance(row: Pick<ComplianceFlagBoardRow, 'status'>): boolean {

  return row.status === FlagStatus.Open;
}
